import { IconButton, Button } from '@sweep-io/sweep-design';
import { useExpandedMode } from './useExpandedMode';
import { ACTIONS_EVENTS } from '../../../../services/events';
import useSendBiEvent from '../../../../hooks/useSendBiEvent';
import { Expand } from '@sweep-io/sweep-design/dist/icons';
import { Box, Tooltip } from '@mui/material';

export const ExpandedModeButton = () => {
  const sendBiEvent = useSendBiEvent();

  const { isExpandedMode, setIsExpandedMode, isCanvasUnited } = useExpandedMode();
  const text = isExpandedMode ? 'Canvas View' : 'Full Page';

  const onClick = () => {
    const _isExpandedMode = !isExpandedMode;
    setIsExpandedMode(_isExpandedMode);

    const state = _isExpandedMode ? 'maximized' : 'minimized';

    sendBiEvent({
      name: ACTIONS_EVENTS.panelStateChange,
      props: {
        source: isCanvasUnited ? 'canvas' : 'app',
        state,
      },
    });
  };

  if (!isCanvasUnited) {
    return null;
  }

  return (
    <Box sx={{ button: { whiteSpace: 'nowrap' } }}>
      {isExpandedMode ? (
        <Button
          dataTestId="expanded-mode-button"
          startIconName="Minimize"
          variant="system"
          size="tiny"
          onClick={onClick}
        >
          {text}
        </Button>
      ) : (
        <Tooltip title={text}>
          <IconButton variant="flat" size="tiny" onClick={onClick}>
            <Expand />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};
